import { Button, Col, Row, Drawer, Form, Input, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { useGlobalState } from '../../store/state';
import InfluencerSelectControlComponent from '../../components/Brand/InfluencerList/InfluencerSelectControlComponent';
import EmptyInfluencerComponent from '../../components/Brand/InfluencerList/EmptyInfluencerComponent';
import { CreateInfluencerList } from '../../apis/Brand/InfluencerList/CreateInfluencerList';
import { GetInfluencerLists } from '../../apis/Brand/InfluencerList/GetInfluencerLists';
import { GetInfluencerListData } from '../../apis/Brand/InfluencerList/GetInfluencerListData';
import OpenedInfluencerListComponent from '../../components/Brand/InfluencerList/OpenedInfluencerListComponent';
import { AiFillInstagram, AiFillYoutube, AiOutlineTwitter } from 'react-icons/ai';
// import { FaFacebookF } from 'react-icons/fa'

const { Option } = Select;
export const BrandInfluencerListPage = () => {
  // const history = useHistory();
  const [formCreateList] = Form.useForm();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [listDraw, setListDraw] = useState(false);
  // const [activeList,setActiveList] = useState({
  //     id:'',
  //     page:1
  // })
  const [availableLists, setAvailableLists] = useState([]);
  const [opendInfluData, setOpendInfluData] = useState({});
  const showDrawer = () => {
    setListDraw(true);
  };
  const onClose = () => {
    setListDraw(false);
  };

  const setAllLists = () =>{
    GetInfluencerLists(user.accessToken, company.selected.id).then(({ status, response })=>{
      console.log('msg from set listy', response);
      if (status === 200 && response.list.length) {
        setAvailableLists([
          ...response.list,
        ]);
      }
    });
  };
  const setListLoadingData = (id, page) =>{
    GetInfluencerListData(
      user.accessToken,
      company.selected.id,
      id,
      page,
    ).then(({ status, error, response })=>{
      console.log('list set', response);
      if (status === 200) {
        setOpendInfluData({
          ...opendInfluData,
          ...response,
        });
      } else {
        console.log('error', error);
      }
    });
  };


  const onFormSubmit =({ listname, platform }) =>{ // create new list
    const _data = {
      brand: company.selected.id,
      listname,
      platform,
    };
    CreateInfluencerList(user.accessToken, _data).then(({ status, response }) =>{
      console.log('insta', response);
      if (status === 200) {
        onClose();
        message.success('New Influencer List Created Successfully');
        setAllLists();
      }
    });
  };


  useEffect(() => {
    // GetInfluencerLists(user.accessToken,company.selected.id).then(({response})=>{
    //     // console.log("ava",response)
    //     if(response.list.length){
    //         setAvailableLists([
    //             ...response.list
    //         ])
    //     }
    // })
    setAllLists();
  }, []);

  useEffect(()=>{
    if (availableLists.length) {
      setListLoadingData(availableLists[0]._id, 1);
    }
  }, [availableLists]);

  const influListOnChange = (value) =>{
    console.log('influ list change', value);
    setListLoadingData(value, 1);
  };

  //
  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="px-3 py-2 sticky">
        <div className="d-flex justify-content-between align-items-center">
          <div>
                        Influencers List
          </div>
          <div className="create_list">
            <Button className="common_button outlined py-2"
              onClick={showDrawer}>Create a new List</Button>
            {
              availableLists.length ?
                <InfluencerSelectControlComponent lists={availableLists}
                  listOnChange={influListOnChange}/>:
                null
            }
            <Drawer
              title="Create new Influencer list"
              placement="right"
              closable={false}
              onClose={onClose}
              visible={listDraw}
              width={280}
            >
              <Form
                form={formCreateList}
                layout="vertical"
                // name="createInfluList"
                requiredMark={false}
                onFinish={onFormSubmit}
              >
                <Form.Item
                  label="Select a list platform"
                  name="platform"
                  rules={[
                    { required: true, message: 'Please select a platform' },
                  ]}
                >
                  <Select placeholder="Please select a platform"
                    size="large">
                    <Option value="youtube"><AiFillYoutube size={18}
                      color="#FF0000"/> Youtube</Option>
                    <Option value="twitter"><AiOutlineTwitter size={18}
                      color="#1DA1F2"/> Twitter</Option>
                    <Option value="instagram"><AiFillInstagram size={18}
                      color="#fb3958"/> Instagram</Option>
                    {/* <Option value="facebook"><FaFacebookF size={16} color="#4267B2"/> Facebook</Option> */}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Enter a desired list name"
                  name="listname"
                  tooltip="Please consider list name as per your platform"
                  rules={[
                    { required: true, message: 'Please enter your list name' },
                    { max: 50, message: 'Maximum 50 characters allowed' },
                  ]}
                >
                  <Input size="large"
                    type="text"
                    placeholder="Eg: Top insta creators" />
                </Form.Item>

                <div className="text-right pt-2">
                  <Button htmlType="submit"
                    className="common_button">Create List</Button>
                </div>
              </Form>
            </Drawer>
          </div>
        </div>

      </BrandTopSubHeaderComponent>
      <div className="p-2">
        {
          Object.keys(opendInfluData).length ?
            <OpenedInfluencerListComponent {...opendInfluData}
              setListLoadingData={setListLoadingData}/>:
            <EmptyInfluencerComponent>There is no list available. <span onClick={showDrawer}
              style={{ cursor: 'pointer', color: '#8d2fc0' }}> Please create your list</span> </EmptyInfluencerComponent>
        }
      </div>
    </BrandBaseLayoutComponent>
  );
};
